module.exports = __webpack_public_path__ + "a286514c6dea3d96496d556b3d63743c.png";